import klass from './SectionA.module.scss';
import { CustomEventWithDetail, type Html, html, on, View } from 'rune-ts';
import { cx } from '../util';
import { Icon } from '../Icon/Icon.ts';
import { ButtonColorChipClickEvent } from '@modules/NewMaker/UI/ButtonColorChip/ButtonColorChip.ts';

export interface SectionAProps {
  title: string;
  subtitle?: string;
  helpText?: boolean;
  klass?: string;
  content: View | Html;
}

export class QuestionMarkClickEvent extends CustomEventWithDetail<SectionAProps> {}

export class SectionA extends View<SectionAProps> {
  protected get content(): View | Html {
    return this.data.content;
  }

  override template() {
    const { title, subtitle, helpText, klass: customKlass } = this.data;

    return html`
      <div class="${cx(klass.section_a, customKlass)}">
        <div class=${klass.header}>
          <div class=${klass.title_container}>
            <div class=${klass.title}>${title}</div>
            ${subtitle ? html` <div class=${klass.subtitle}>- ${subtitle}</div>` : ''}
          </div>
          ${helpText
            ? html`<div class="${klass.question_mark}">
                ${new Icon({ name: 'information', class: 'question_mark', size: 20 })}
              </div>`
            : ''}
        </div>
        <div class="${klass.content}">${this.content}</div>
      </div>
    `;
  }

  override onRender() {
    this.addEventListener(ButtonColorChipClickEvent, (e) => {
      const { name, is_more_button } = e.detail;
      if (is_more_button) {
        console.log(this.content);
      }
      if (this.data.subtitle && name) this.updateSubTitle(name);
    });
  }

  updateSubTitle(subtitle: string, targetEl?: HTMLElement) {
    this.data.subtitle = subtitle;

    const subtitle_el = this.element().querySelector(`.${klass.subtitle}`);
    if (!subtitle_el) return;

    if (targetEl) {
      if (targetEl.firstChild) {
        targetEl.firstChild.textContent = subtitle + ' ';
      }
    } else {
      subtitle_el.textContent = `- ${subtitle}`;
    }
  }

  @on('click', `.${klass.question_mark}`)
  _onClickQuestionMark() {
    this.dispatchEvent(QuestionMarkClickEvent, {
      bubbles: true,
      detail: this.data,
    });
  }
}
